// Personal Affirmation Pin — a member can pin ONE favourite affirmation
// from the library and it will surface on the Home page for seven days.
// Storage is local (per device) which matches the mocked-auth pattern.

const KEY = "n8one.pinned-affirmation.v1";
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

function safeParse(raw) {
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}

/**
 * Read the current pin. Returns `null` when nothing is pinned OR when the
 * 7-day window has quietly expired.
 */
export function getPinnedAffirmation() {
  if (typeof window === "undefined") return null;
  const p = safeParse(window.localStorage.getItem(KEY));
  if (!p || !p.text || !p.expires_at) return null;
  if (new Date(p.expires_at).getTime() < Date.now()) {
    try { window.localStorage.removeItem(KEY); } catch { /* noop */ }
    return null;
  }
  return p;
}

/**
 * Pin an affirmation. Overrides any existing pin. Auto-expires after 7 days.
 */
export function pinAffirmation({ text, category = "" }) {
  if (typeof window === "undefined") return null;
  const clean = (text || "").trim();
  if (!clean) return null;
  const now = new Date();
  const payload = {
    text: clean,
    category,
    pinned_at: now.toISOString(),
    expires_at: new Date(now.getTime() + SEVEN_DAYS_MS).toISOString(),
  };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(payload));
    // Broadcast so other tabs / listeners can refresh without a page reload.
    window.dispatchEvent(new CustomEvent("pinned-affirmation-changed"));
  } catch { /* noop */ }
  return payload;
}

/**
 * Remove the pin.
 */
export function clearPinnedAffirmation() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
    window.dispatchEvent(new CustomEvent("pinned-affirmation-changed"));
  } catch { /* noop */ }
}

/**
 * How many days remain (rounded down, never negative).
 */
export function daysRemaining(expires_at) {
  if (!expires_at) return 0;
  const ms = new Date(expires_at).getTime() - Date.now();
  return Math.max(0, Math.floor(ms / (24 * 60 * 60 * 1000)));
}
